import React from "../_snowpack/pkg/react.js";
import {Documentation, documentation} from "../services/DocumentationService.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
export const InfoPane = (props) => {
  const {i18n} = useTranslation();
  function createMarkup(body) {
    return {__html: body};
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: Documentation[props.documentation],
    dangerouslySetInnerHTML: createMarkup(documentation(i18n.resolvedLanguage, props.documentation))
  });
};
